var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgermenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.357 0.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1132",
    "data-name": "Rectangle 1132",
    width: 30,
    height: 30,
    transform: "translate(29.643 29.643) rotate(180)",
    fill: "#5e6d97",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M1.173,0H21.059a1.173,1.173,0,0,1,1.173,1.173V1.3A1.173,1.173,0,0,1,21.059,2.47H1.173A1.173,1.173,0,0,1,0,1.3V1.173A1.173,1.173,0,0,1,1.173,0Z",
    transform: "translate(3.705 13.586)",
    fill: "#5e6d97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M1.173,0H21.059a1.173,1.173,0,0,1,1.173,1.173V1.3A1.173,1.173,0,0,1,21.059,2.47H1.173A1.173,1.173,0,0,1,0,1.3V1.173A1.173,1.173,0,0,1,1.173,0Z",
    transform: "translate(3.705 19.762)",
    fill: "#5e6d97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M1.173,0H21.059a1.173,1.173,0,0,1,1.173,1.173V1.3A1.173,1.173,0,0,1,21.059,2.47H1.173A1.173,1.173,0,0,1,0,1.3V1.173A1.173,1.173,0,0,1,1.173,0Z",
    transform: "translate(3.705 7.411)",
    fill: "#5e6d97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgermenu);
export default __webpack_public_path__ + "static/media/burgermenu.3f35b67d09ab976ea88c63b99a394c60.svg";
export { ForwardRef as ReactComponent };